export default __webpack_public_path__ + "static/media/scotiabank-logo.cba50361.svg";